class AccessibilityHelper {
    /**
     * @returns {boolean}
     */
    static prefersReducedMotion() {
        const query = '(prefers-reduced-motion: reduce)';
        return window.matchMedia(query).matches;
    }
}

export default AccessibilityHelper;
